import React from 'react';
import { motion } from 'framer-motion';
import { useReducedMotion } from './useReducedMotion';
import { tweenNormal } from './springs';

const pageVariantsFull = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: tweenNormal },
  exit: { opacity: 0, y: -8, transition: { duration: 0.2 } },
};

const pageVariantsReduced = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.15 } },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};

export function PageTransition({ children, className = '' }) {
  const reducedMotion = useReducedMotion();
  const variants = reducedMotion ? pageVariantsReduced : pageVariantsFull;

  return (
    <motion.div
      className={className}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      style={{
        minHeight: '100%',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;
